import { Button, Tooltip } from 'framework/ui/mui-builder';
import React, { useState } from 'react';
import { Modal } from 'framework/ui/ui-builder';
import { ModalForm } from 'framework/form';
import useRiskService from '../useRiskService';
import { useNewProjectUrl } from 'domain/shared/newProject';
import { Box, IconButton, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

interface DeleteRiskModalProps {
  projectId: string;
  id: string;
  isInMainSection?: boolean;
}

const DeleteRiskModal = ({ projectId, id, isInMainSection = false }: DeleteRiskModalProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { deleteRisk } = useRiskService();
  const { getRisksUrl } = useNewProjectUrl();

  return (
    <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
      {isInMainSection ? (
        <Tooltip title={'Delete risk'}>
          <IconButton color="primary" onClick={() => setModalOpen(true)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Button variant="contained" color="error" onClick={() => setModalOpen(true)}>
          Delete risk
        </Button>
      )}
      <Modal isOpen={modalOpen} onToggle={() => setModalOpen(false)} title="Delete risk">
        <ModalForm
          closeModal={() => setModalOpen(false)}
          modalOpen={modalOpen}
          submitFormFunc={() => deleteRisk(id)}
          afterSubmit={{
            redirect: getRisksUrl(projectId),
            message: 'You are awesome! The Risk has been successfully deleted.',
          }}
        >
          <Typography pb={4}>Are you sure you want to delete this risk?</Typography>
        </ModalForm>
      </Modal>
    </Box>
  );
};

export default DeleteRiskModal;
